<template>
  <div class="library">
    <div class="title">我的订单</div>
    <div class="cont">
      <div class="c-c">
        <div class="c-c-l">
          <div class="c-c-l-t" v-for="(item, index) in typeList" :key="item.id">
            <span :class="typeCurrent == index ? 'typeActive' : 'typeNormal'" @click="typeFun(item, index)">{{
                item.name
              }}</span>
          </div>
        </div>
      </div>
      <div class="content" v-if="data.length >0">
        <div class="list mt-20" v-for="(order,index) in data" :key="index">
          <a-row type="flex">
            <div class="pt-20 ml-20">订单编号: {{ order.outTradeNo }}</div>
            <p class="status green" v-if="order.paymentStatus==1">已支付</p>
            <p class="status red" v-if="order.paymentStatus==0">待支付</p>
            <p class="status gray" v-if="order.paymentStatus==3">已取消</p>
            <p class="status gray" v-if="order.paymentStatus==2">支付失败</p>
          </a-row>
          <a-row type="flex" justify="space-around" class="ml-20">
            <img class="img_1" :src="resBasePath + order.photoPath"
                 style="height:100px;margin-right: 40px;margin-bottom: 20px;width: auto;display: block;object-fit: cover;"/>

            <a-col flex="auto" class="info">
              <div class="buy-title">{{ order.productName }}</div>
              <div class="mt-20 a-col">订单金额： <span style="color: #fa5542;">¥{{ order.orderAmount }}</span></div>
              <div class="mt-10" v-if="order.paymentStatus!=3">
                付款时间：{{ order.paymentDate !== null ? format.format(order.paymentDate) : '-----' }}
              </div>
              <div class="mt-10" v-if="order.paymentStatus==3">
                取消时间：{{ order.paymentDate !== null ? format.format(order.paymentDate) : '-----' }}
              </div>
            </a-col>

            <a-col flex="300px">
              <div class="buy-title" style="visibility: hidden"> 0</div>
              <div class="mt-20">创建时间：{{ format.format(order.createDate) }}</div>
              <div class="mt-10">有效期至：{{ order.expireDate !== null ? format.format(order.expireDate) : '-----' }}
              </div>
            </a-col>
            <a-col flex="160px" align="middle">

              <div v-if="order.paymentStatus==0">
                <a-statistic-countdown
                    title="等待付款 "
                    :value="order.paymentExpireTime||1717491350000"
                    format="mm:ss"
                    class="a-statistic-countdown"
                />
              </div>
              <div @click="applyCheck(order,index)" class=" green-click"
                   v-if="order.paymentStatus==1 && order.isInvoice==0">申请发票
              </div>
              <div class=" green-noclick" v-if="order.paymentStatus==1 && order.isInvoice==1">申请中</div>
              <div @click="payOrder(order,index)" class="red-click mt-20" v-if="order.paymentStatus==0">立即支付</div>
              <div @click="cancelOrder(order,index)" class=" gray-click mt-10" v-if="order.paymentStatus==0">取消订单
              </div>
            </a-col>

          </a-row>
        </div>
      </div>
      <div class="d-table" v-if="data.length==0">
        <img class="no-data" src="../../assets/image/no-data.png" alt=""/>
        <div>
          <span style="font-size: 16px">暂无订单信息</span>
        </div>
      </div>
      <div class="page-bot" v-if="data.length >0">
        <div class="left">共{{ total || 0 }}条数据</div>
        <div class="right">
          <a-config-provider>
            <a-pagination show-quick-jumper size="small" :current="pageNum" :page-size="pageSize"
                          @change="handleListChange" show-less-items :total=total>
            </a-pagination>
          </a-config-provider>
        </div>
      </div>
    </div>

    <a-modal title="申请发票" centered width="600px" :visible="applyCheckVisible"
             @cancel="() => { this.applyCheckVisible = false }"
             footer="">
      <div class="applyCheck">
        <div class="flex-row flex-grow mt-10">
          <span class="info-must">*</span>
          <span class="info-title "> 单位名称：</span>
          <a-input class="info-content" placeholder="请输入单位名称" v-model="companName"></a-input>
        </div>
        <div class="flex-row flex-grow mt-10">
          <span class="info-must">*</span>
          <span class="info-title "> 单位税号：</span>
          <a-input class="info-content" placeholder="请输入单位税号" v-model="companNo"></a-input>
        </div>
        <div class="flex-row flex-grow mt-10 fax-tips">
          <span class="info-must">*</span>
          <span class="info-title"> 邮箱：</span>
          <a-input class="info-content" placeholder="请输入邮箱" v-model="email"></a-input>
          <a-tooltip placement="top" title="电子发票将在7个工作日内发送至您的邮箱，遇节假日顺延，感谢您的理解">
            <!--            <a-button class="info-tips" type="primary" shape="circle" icon="exclamation-circle"></a-button>-->
            <a-icon type="exclamation-circle" class="info-tips"/>
          </a-tooltip>
        </div>
        <div class="info-tip"></div>
        <div class="flex-row flex-grow mt-10">
          <span class="info-must">*</span>
          <span class="info-title "> 联系电话：</span>
          <a-input class="info-content" placeholder="请输入联系电话" v-model="companPhone"></a-input>
        </div>
        <div class="f-del">
          <div class="f-c" @click="() => { this.applyCheckVisible = false }">取消</div>
          <div class="f-s" @click="applyCheckVSure">确认</div>
        </div>
      </div>
    </a-modal>
    <a-modal title="取消订单" centered :visible="cancelOrderVisible" @cancel="() => { this.cancelOrderVisible = false }"
             width="460px"
             footer="">
      <div class="cancelOrder">
        <div class="tip">订单取消后无法恢复，请谨慎操作。</div>
        <div class="title">请选择取消订单原因</div>
        <a-radio-group v-model="value" @change="onChangeCancelOrder" style="width: 100%">
          <a-radio :style="radioStyle" :value="'商品价格太贵'">
            商品价格太贵
          </a-radio>
          <a-radio :style="radioStyle" :value="'暂时不需要了'">
            暂时不需要了
          </a-radio>
          <a-radio :style="radioStyle" :value="'其他原因'" style="text-align: start">
            其他原因
          </a-radio>
          <a-textarea v-if="value === '其他原因'" :style="{ width: 200 , marginLeft: 10 }" v-model="remark"
                      :maxLength="50"
                      :auto-size="{ minRows: 2, maxRows: 6 }"/>
          <span v-if="value === '其他原因'"
                style="position: relative;left: 360px;user-select: none;z-index: 999;top: -24px;">{{
              remark.length
            }}/50</span>
        </a-radio-group>
      </div>
      <div class="f-del">
        <div class="f-c" @click="() => { this.cancelOrderVisible = false }">取消</div>
        <div class="f-s" @click="cancelOrderSure">确认</div>
      </div>
    </a-modal>

    <a-modal title="立即支付" v-model="payOrderVisible" :footer="null" width="1000px" centered :destroyOnClose=true
             :maskClosable="false" @cancel="buyClose">
      <div v-if="true">
        <div class="flex-row justify-between">
          <div class="buy-title">商品信息</div>
        </div>
        <div class="buy-info mt-10">
          <div class="info-container">
            <div class="left-div">
              <img class="info-img" :src="resBasePath + currentOrder.photoPath"
                   style="height:170px; width: auto;display: block;object-fit: cover;margin: auto"/>
            </div>
            <div class="right-div">
              <div class="top-div">
                <span class="info-status">支持开发票</span>
              </div>
              <div class="middle-div">
                <p class="buy-title">{{ currentOrder.productName }}</p>
                <p style="font-size: 18px;font-weight: bolder;  color: #fa5542;">¥ {{ currentOrder.orderAmount }}/年</p>
              </div>
              <div class="bottom-div">
                <p class="buy-content">{{ currentOrder.purchaseDescription }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="buy-title mt-20">填写基本信息</div>
        <div class="flex-row mt-10">
          <div class="flex-row flex-grow">
            <span class="info-must">*</span>
            <span class="info-title "> 姓名：</span>
            <a-input v-model="customName" class="info-content" placeholder="请输入真实姓名" :disabled="true"></a-input>
          </div>
          <div class="flex-row flex-grow ml-20">
            <span class="info-must">*</span>
            <span class="info-title"> 身份证号：</span>
            <a-input v-model="customNo" placeholder="请输入身份证号" @change="onContentChange"
                     :disabled="true"></a-input>
          </div>
        </div>
        <div class="flex-row mt-10">
          <div class="flex-row flex-grow" style="visibility: hidden">
            <span class="info-title"> </span>
            <span class="info-title"> </span>
            <span class="info-title"> </span>
            <span class="info-title"> </span>
          </div>
          <div class="flex-row flex-grow">
            <span class="info-must" style="font-size: 12px;">{{ contentTips }}</span>
          </div>
        </div>
        <div class="buy-title mt-20">支付方式</div>
        <div class="flex-row flex-grow ml-20">
          <div class=" mt-10" style="width:140px;height:80px;cursor: pointer;" @click="gotoPay(1)">
            <img class="buy-img" src="../../assets/image/pay-ali.png" v-if="!showAliQrcode"/>
            <img class="buy-img" src="../../assets/image/pay-ali-selected.png" v-if="showAliQrcode"/>
          </div>
          <div class=" mt-10" style="width:140px;height:80px;cursor: pointer;" @click="gotoPay(2)">
            <img class="buy-img" src="../../assets/image/pay-wechat.png" v-if="!showWechatQrcode"/>
            <img class="buy-img" src="../../assets/image/pay-chat-selected.png" v-if="showWechatQrcode"/>
          </div>
        </div>
        <div v-if="showQrcode">
          <a-spin tip="加载中..." :spinning="showQrcodeLoading">
            <div style="text-align: center;font-size: small;margin-top: -20px">扫描下方二维码完成支付</div>
            <div style="text-align: center" class="pb-1">
              <div class="qrcode-content" ref="qrcode" style="border:none;margin-top: 10px"></div>
            </div>
            <div style="text-align: center;font-size: small;margin-top: 10px">
              <a-statistic-countdown
                  prefix="请在"
                  suffix="内完成支付，否则订单会自动取消"
                  :value="(currentOrder.paymentExpireTime)||1717491350000"
                  format="mm:ss"/>
            </div>
          </a-spin>
        </div>
      </div>
      <div v-if="false">
        <div class="d-table">
          <img class="no-data" src="../../assets/image/no-data.png" alt=""/>
          <div>
            <span style="font-size: 16px">暂无购买产品信息</span>
          </div>

        </div>
      </div>
    </a-modal>
  </div>

</template>

<script>
import { isImg, isAudio, isVideo } from '@/utils/getFileInfo.js'
import format from '../../utils/format.js'
import FilePreview from 'components/FilePreview'
import axios from 'axios'
import QRCode from 'qrcodejs2'

export default {
  name: 'MyOrder',
  data () {
    return {
      format,
      resBasePath: this.$resBasePath + '/',
      teacherId: this.$store.state.userId || JSON.parse(localStorage.getItem('user_info')).id,
      taskCurrent: -1,
      typeCurrent: 0,
      typeList: [
        { name: '全部订单', id: '' },
        { name: '待支付', id: 0 },
        { name: '已支付', id: 1 },
        { name: '已取消', id: 3 }

      ],
      dataList: [],
      classList: this.$store.state.classList || [],
      access_token: this.$store.state.access_token,
      columns: [],
      newVis: false,
      newName: '', // 文件夹名称
      removeVis: false, // 移动弹窗
      value: '',
      radioStyle: {
        display: 'block',
        height: '35px',
        lineHeight: '35px',
        width: '100%'
      },
      selectedRows: [],
      shareVis: false,
      plshareVis: false,
      fileType: '',
      delVis: false,
      // rowSelection,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      reNameVis: false,
      editNameMess: {},
      delMess: {},
      classListSelected: this.$store.getters.allClassIds, // 单个共享班级
      allClassListSelected: this.$store.getters.allClassIds, // 批量资源共享班级
      fileId: 0,
      myFolderList: [], // 文件夹列表
      moveIds: [], // 要移动的文件夹单个
      moveTargetId: '', // 目标文件夹
      folderFlag: true, // 跳转到文件夹的名字 如果为真 则默认为上传的是所在的文件夹 //是否是文件夹 默认是文件夹
      folderName: '', // 目标文件名称
      uploadFlag: true, // 是否可以上传 // 默认可以上传 如果选择的是文件则不能上传
      shareList: [],
      shareFlag: false,
      selectedRowKeys: [],
      allShareName: '', // 共享的名称
      zyLength: 0, // 共享的条数
      parentId: 0, // 默认创建文件夹时候 为0
      imgView: false,
      previewFile: { name: '', url: '' },
      videoList: [],
      searchFileName: '', // 搜索框输入内容
      isSearch: false,
      seleceList: [],
      checkedKeys: [],
      loadedKeys: [], // 不保留，myFolderList改变时，节点展开状态会丢失
      allDirs: [], // 保存所有目录，用于判断目录层次

      currentOrder: {},
      companName: '',
      companNo: '',
      email: '',
      companPhone: '',
      remark: '',
      applyCheckVisible: false,
      payOrderVisible: false,
      cancelOrderVisible: false,
      loading: false,
      loadingMore: false,
      showLoadingMore: false,
      countdown: '',
      data: [],

      contentTips: '', // 初始文本
      qrcode: null,
      customName: '',
      customNo: '',
      showQrcode: false,
      T: '', // 定时器的ID
      showQrcodeLoading: false,
      showWechatQrcode: false,
      showAliQrcode: false,
      payType: 1
    }
  },
  mounted () {
    this.getDataList()
    this.getOrderPage()
    this.loading = false
  },
  methods: {
    timeDifference (givenTimeMillis) {
      const currentTime = new Date().getTime()
      const diff = givenTimeMillis - currentTime
      if (diff <= 0) {
        this.countdown = '00:00'
        return
      }
      const seconds = Math.floor(diff / 1000)
      const minutes = Math.floor(seconds / 60)
      const secs = seconds % 60
      this.countdown = `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },
    clearData () {
      this.selectedRowKeys = [] // 调用这个方法就有效果了
      this.$forceUpdate()
    },
    getDataList (param) {
      // if (param == null) {
      //   param = {
      //     id: this.fileId,
      //     fileName: this.isSearch ? this.searchFileName : '',
      //     pageNum: this.pageNum,
      //     pageSize: this.pageSize,
      //     fileType: this.fileType,
      //     access_token: this.access_token,
      //     teacherId: this.teacherId
      //   }
      // }
      // this.$fetch({
      //   url: this.$httpConfig.getFilePage,
      //   body: param
      // }).done((res) => {
      //   // todo 注意 接口返回参数  isFolder  0：文件夹  1：文件
      //   if (res && res.success && res.resultData && res.resultData) {
      //     this.dataList = res.resultData.list
      //    // this.total = res.resultData.total
      //     this.clearData()
      //   }
      // })
    },
    onChangeCancelOrder (e) { // 发布学生端班级筛选
      console.log(e.target.value)
    },
    typeFun (item, index) {
      this.typeCurrent = index
      this.fileType = item.id
      this.pageNum = 1
      this.searchFileName = ''
      this.getOrderPage()
    },
    applyCheck (order, index) {
      // 申请发票弹框
      this.applyCheckVisible = true
      this.currentOrder = order
      this.getPurchaseUserInfo()
      console.log(order)
    },
    payOrder (order, index) {
      this.payOrderVisible = true
      this.currentOrder = order
      // this.getPurchaseUserInfo()
      this.customName = this.currentOrder.name
      this.customNo = this.currentOrder.idNumber
      this.gotoPay(1)
      console.log(order)
    },
    cancelOrder (order, index) {
      this.cancelOrderVisible = true
      this.currentOrder = order
      console.log(order)
    },
    applyCheckVSure (order, index) {
      // 申请发票确定
      if (this.companName === '' || this.companName === null) {
        this.$message.error('请输入单位名称')
        return
      }
      if (this.companNo === '' || this.companNo === null) {
        this.$message.error('请输入单位税号')
        return
      }
      if (this.companNo && this.companNo.length !== 18) {
        this.$message.error('单位税号应为18位')
        return
      }
      if (this.email === '' || this.email === null) {
        this.$message.error('请输入邮箱')
        return
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.email)) {
        this.$message.error('邮箱格式不正确')
        return
      }
      if (this.companPhone === '' || this.companPhone === null) {
        this.$message.error('请输入联系电话')
        return
      }

      // 手机号码正则表达式（中国大陆）
      const mobileRegex = /^1[3456789]\d{9}$/
      // 固定电话号码正则表达式（简单版，仅包含3-4位区号和7-8位号码）
      const phoneRegex = /^\d{3,4}-\d{7,8}$/
      const reg = mobileRegex.test(this.companPhone) || phoneRegex.test(this.companPhone)
      if (!reg) {
        this.$message.error('电话号码格式不正确')
        return
      }
      // 保存发票信息
      this.saveInvoice()

      console.log(order)
    },
    cancelOrderSure (order, index) {
      // 取消订单确定

      // 取消订单
      this.cancelOrderPurchase()
      console.log(order)
    },
    payOrderSure (order, index) {
      // 立即支付确定
      this.payOrderVisible = false
      console.log(order)
    },
    handleEmailChange (e) {
      const value = e.target.value
      // 使用正则表达式验证是否为有效邮箱
    },
    saveInvoice () {
      // 保存发票信息
      const _this = this
      this.$fetch({
        // url: this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode',
        url: this.$baseUrl + 'ebook/purchase/v3/saveInvoice',
        body: {
          // 1：学生端 2：教师端
          id: this.currentOrder.id,
          invoiceOrganName: this.companName,
          invoiceTaxIdNumber: this.companNo,
          invoiceEmail: this.email,
          invoicePhone: this.companPhone,
          userId: this.$getUserInfo().id,
          access_token: this.access_token
        }
      }).done((res) => {
        if (res && res.resultData) {
          // 支付成功
          _this.$message.success('申请发票成功')
          _this.getOrderPage()
          _this.applyCheckVisible = false
        } else {
          _this.$message.error('申请发票失败')
        }
      })
    },
    cancelOrderPurchase () {
      // 取消订单
      if (!(this.remark || this.value)) {
        this.$message.error('取消订单原因不能为空')
        return
      }
      const cancelReason = this.remark === '' ? this.value : this.remark
      console.log('cancelReason', cancelReason)
      const _this = this
      this.$fetch({
        // url: this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode',
        url: this.$baseUrl + 'ebook/purchase/v3/cancelOrder',
        body: {
          // 1：学生端 2：教师端
          id: this.currentOrder.id,
          cancelReason: cancelReason
        }
      }).done((res) => {
        if (res && res.resultData) {
          // 支付成功
          _this.$message.success('取消订单成功')
          this.cancelOrderVisible = false
          this.remark = ''
          this.value = ''
          this.getOrderPage()
        } else {
          _this.$message.error('取消订单失败')
        }
      })
    },
    getPurchaseUserInfo () {
      // 保存或修改购买用户信息
      const _this = this
      this.$fetch({
        // url: this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode',
        url: this.$baseUrl + 'ebook/purchase/v3/getPurchaseUserInfo',
        body: {
          userId: this.$getUserInfo().id,
          access_token: this.access_token
        }
      }).done((res) => {
        if (res && res.resultData) {
          // 支付成功
          _this.customName = res.resultData.name
          _this.customNo = res.resultData.idNumber
          _this.companName = res.resultData.invoiceOrganName
          _this.companNo = res.resultData.invoiceTaxIdNumber
          _this.email = res.resultData.invoiceEmail
          _this.companPhone = res.resultData.invoicePhone
        }
      })
    },
    getOrderPage () {
      // 订单列表
      const _this = this
      this.$fetch({
        // url: this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode',
        url: this.$baseUrl + 'ebook/purchase/v3/getOrderPage',
        body: {
          userId: this.$getUserInfo().id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          paymentStatus: this.fileType,
          access_token: this.access_token
        }
      }).done((res) => {
        if (res && res.resultData) {
          // 支付成功
          _this.data = res.resultData.list
          _this.total = res.resultData.total
          // 每秒更新倒计时
          // setInterval(() => {
          //   this.timeDifference(1717034322000);
          // }, 1000);
        }
      })
    },
    handleListChange (current, pagesize) {
      this.pageNum = current
      this.pageSize = pagesize
      this.getOrderPage()
    },
    onContentChange () {
      if (!this.customNo) {
        this.contentTips = '* 请输入身份证号'
        return
      }
      if (!this.isValidChineseID(this.customNo)) {
        this.contentTips = ('* 身份证号码格式不正确')
        return
      }
      if (!this.isAgeGreaterThan16(this.customNo)) {
        this.contentTips = ('* 不满16周岁禁止自主购买')
        return
      }
      this.contentTips = ''
    },
    gotoPay (index) {
      // 二维码再生成（（网站）
      if (this.T) {
        clearInterval(this.T)
      }
      this.T = null
      // 加载进度条
      this.showQrcodeLoading = true
      // 支付方式
      this.payType = index
      let url = ''
      if (index === 1) {
        // 支付宝二维码
        this.showAliQrcode = true
        this.showWechatQrcode = false
        url = this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCodeRefresh'
      } else {
        // 微信二维码
        this.showWechatQrcode = true
        this.showAliQrcode = false
        url = this.$baseUrl + 'ebook/purchase/v3/h5WeChatPayOrderQrCodeRefresh'
      }
      this.$fetch({
        // url: this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode',
        url: url,
        body: {
          outTradeNo: this.currentOrder.outTradeNo,
          access_token: this.access_token
        }
      }).done((res) => {
        if (res && res.resultData) {
          if (index === 1) {
            this.showQrcodeLoading = false
            this.showQrcode = true
            // this.showAliQrcode = false
            // this.currentOrder = res.resultData
            this.$nextTick(() => {
              this.creatQrCode(res.resultData.qrCodeLink)
            })
            this.loopOrderState(res.resultData.outTradeNo)
          } else {
            this.showQrcodeLoading = false
            this.showQrcode = true
            // this.showWechatQrcode = false
            // this.currentOrder = res.resultData
            this.$nextTick(() => {
              this.creatQrCode(res.resultData.qrCodeLink)
            })
            this.loopOrderState(res.resultData.outTradeNo)
          }
        }
      })
    },
    loopOrderState (id) {
      // 轮询当前订单状态s
      this.T = setInterval(() => {
        this.checkCode(id)
      }, 3000)
    },
    creatQrCode (id) {
      if (this.qrcode) {
        this.qrcode.clear()
        this.qrcode.makeCode(id)
        return
      }
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: id, // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    buyClose () {
      this.showQrcode = false
      this.showQrcodeLoading = false
      this.showAliQrcode = false
      this.showWechatQrcode = false
      this.qrcode = null
      if (this.T) {
        clearInterval(this.T)
      }
      this.T = null
    },
    checkCode (id) {
      // 轮询支付状态（网站）
      const _this = this
      let url = ''
      if (_this.payType === 1) {
        url = _this.$baseUrl + 'ebook/purchase/v3/h5AlipayPollingQueryOrder'
      } else {
        url = _this.$baseUrl + 'ebook/purchase/v3/h5WechatPollingQueryOrder'
      }
      this.$fetch({
        // url: this.$baseUrl + 'ebook/purchase/v3/h5AliPayOrderQrCode',
        url: url,
        body: {
          outTradeNo: id,
          access_token: _this.access_token
        }
      }).done((res) => {
        if (res && res.resultData) {
          // 支付成功
          _this.$message.success('支付成功')
          _this.payOrderVisible = false
          _this.buyClose()
          _this.getOrderPage()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pageHeaderList {
  margin-left: 6px;
  margin-right: 6px;
  cursor: pointer;
}

.pageHeaderList:hover {
  color: @primary-color;
}

ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.wj-checkbox {
  margin-left: 30px;
  cursor: pointer;
}

.library {
  .title {
    color: #333;
    font-size: 18px;
    border-bottom: 1px solid #f2f2f2;
    text-indent: 30px;
    height: 50px;
    line-height: 50px;
    font-weight: 600;
  }

  .cont {
    padding: 20px 30px;

    .c-t {
      height: 40px;

      span {
        display: inline-block;
        width: 80px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        margin-right: 20px;
        cursor: pointer;
        border-radius: 2px;
        font-size: 14px;
      }

      .taskNormal {
        color: @primary-color;
        border: 1px solid @primary-color;
      }

      .taskActive {
        background: @primary-color;
        color: #fff;
      }
    }

    .c-c {
      display: flex;

      .c-c-l {
        display: flex;
        flex: 12;

        span {
          display: inline-block;
          width: 70px;
          height: 34px;
          line-height: 30px;
          text-align: center;
          cursor: pointer;
          border-radius: 2px;
        }

        .typeNormal {
          // color: #666;
          // padding: 0 5px;
          background: #FFFFFF;
        }

        .typeActive {
          background: #FFFFFF;
          color: @primary-color;
          border-bottom: 4px solid @primary-color;
          // padding: 0 3px;
        }

        .c-c-l-t {
          background-color: #f1f0f0;
          position: relative;
        }

        .shuLineActive {
          position: absolute;
          right: 0;
          top: 2px;
          color: @primary-color;
        }

        .shuLineNormal {
          position: absolute;
          right: 0;
          top: 2px;
          color: #d8d8d8;
        }
      }

      .c-c-r {
        flex: 12;
        text-align: right;

        /deep/ .ant-input {
          border-radius: 4px;
        }
      }
    }

    .c-b {
      margin-top: 15px;
      display: flex;

      .allWj {
        color: @primary-color;
        cursor: pointer;
      }

      .img {
        width: 16px;
        height: 16px;
        margin: 3px 3px 0px 3px;
      }

      .folder-name {
        line-height: 22px;
      }
    }

    .table {
      margin-top: 10px;

      .share {
        display: inline-block;
        background: #f7ede0;
        width: 60px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: @primary-color;
        font-size: 14px;
        border-radius: 10px;
        cursor: pointer;
      }

      .editable {
        span {
          color: @primary-color;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      .file-name {
        // display: flex;
        cursor: pointer;

        .img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          margin-top: -6px;
        }

        .file-name-t {
          margin-top: 2px;
          width: 160px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.f-del {
  display: flex;
  width: 180px;
  margin-top: 20px;
  margin: 20px auto 0;

  div {
    width: 80px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border-radius: 4px;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }

  .f-c {
    background: #ffffff;
    border: 1px solid #dbd1cd;
    color: #867d7b;

    &:hover {
      color: @primary-color;
    }
  }

  .f-s {
    background: @primary-color;
    color: #fff;
    margin-left: 20px;
  }

  .danger {
    background: red;
    color: #fff;
  }
}

.wj-ul {
  width: 100%;
  height: 340px;
  overflow: auto;

  /deep/ .ant-checkbox-group {
    width: 100% !important;
  }

  .wj-li {
    display: flex;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #edeef1;

    .wj-img {
      width: 20px;
      height: 20px;
    }

    .wj-name {
      font-size: 14px;
      color: #797979;
      margin-left: 15px;
    }
  }
}

/deep/ .ant-modal-body {
  padding: 0 24px 24px;
}

.wj-new1 {
  margin-top: 20px;

  /deep/ .ant-input {
    border-radius: 2px;
  }
}

.wj-new {
  margin-top: 20px;
  margin: 20px auto;
  text-align: center;
  width: 200px;

  .del-img {
    width: 50px;
    height: 50px;
  }

  .del-text {
    line-height: 20px;
    color: #666;
    font-size: 14px;
  }

  /deep/ .ant-upload {
    margin-left: auto;
  }
}

.shareBox {
  display: flex;
  color: #867d7b;
  font-size: 16px;

  .share-m {
    max-width: 280px;
    margin-top: 15px;
    height: 40px;
    line-height: 40px;
    border-bottom: 2px dotted #f9f9f9;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .shareMess {
    width: 100px;
    margin-top: 15px;
    height: 40px;
    line-height: 40px;
    margin-left: 5px;
  }
}

.share-class {
  margin: 15px auto;
  display: flex;
  width: 320px;

  .c-l {
  }

  .c-r {
  }
}

.page-bot {
  display: flex;
  height: 50px;
  line-height: 50px;

  .left {
    margin-top: 5px;
  }

  .right {
    margin-left: auto;
    text-align: right;
    margin-top: 20px;
  }
}

.viewDom {
  text-align: center;
  min-height: 500px;
  padding: 20px;
  max-width: 1000px;
  line-height: 500px;

  img {
    max-width: 1000px;
  }
}

table {
  width: 100%;
}

table th {
  border: 0 !important;
  background-color: #eee;
  text-align: center !important;
  padding: 0 5px;
}

table td {
  border: 0 !important;
  padding: 0 5px;
}

/deep/ .ant-table-thead > tr > th {
  border: none;
}

/deep/ .ant-table-tbody > tr {
  border-bottom: 1px solid #e8e8e8 !important;
}

/deep/ .ant-tree-node-content-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .ant-table-tbody > tr > td {
  border: none;
  border-bottom: 1px solid #e8e8e8 !important;
}

.imgTree {
  width: 16px;
  height: 16px;
  margin-bottom: 14px;
}

.demo-loadmore-list {
  min-height: 350px;
}

.content {
  height: calc(75vh);
  overflow-y: auto;
}

.list {
  background: #ebebeb;
  border-radius: 10px;

  .info {
    margin-top: 0px;
  }

  .status {
    padding: 2px 8px; /* 内边距 */
    //margin: 2px; /* 外边距 */
    // background-color: #ffdddd; /* 背景颜色 */
    text-align: center;
    border-radius: 20px; /* 圆角的半径 */
    margin-top: 15px;
    margin-left: 20px;
  }

  .green {
    border: 1px solid green; /* 边框宽度和颜色 */
    color: green;
  }

  .red {
    border: 1px solid #fa5542; /* 边框宽度和颜色 */
    color: #fa5542;
  }

  .gray {
    border: 1px solid #939393; /* 边框宽度和颜色 */
    color: #939393;
  }

  .buy-title {
    font-weight: bold;
    color: #000000;
    font-size: 16px;
  }

  .green-click {
    width: 90px;
    border: 1px solid dodgerblue; /* 边框宽度和颜色 */
    color: white;
    background-color: dodgerblue; /* 背景颜色 */
    border-radius: 20px; /* 圆角的半径 */
    cursor: pointer;
    margin-top: -35px;
  }

  .green-noclick {
    width: 90px;
    border: 1px solid #99C2FF; /* 边框宽度和颜色 */
    color: white;
    background-color: #98C1FF; /* 背景颜色 */
    border-radius: 20px; /* 圆角的半径 */
    cursor: default;
    margin-top: -35px;
  }

  .red-click {
    width: 90px;
    border: 1px solid #fa5542;; /* 边框宽度和颜色 */
    color: white;
    background-color: #fa5542;; /* 背景颜色 */
    border-radius: 20px; /* 圆角的半径 */
    cursor: pointer;
  }

  .gray-click {
    // border: 1px solid #939393; /* 边框宽度和颜色 */
    color: #939393;
    cursor: pointer;
    // background-color: green; /* 背景颜色 */
  }

}

.cancelOrder {
  .tip {
    margin: 10px;
    padding: 4px;
    text-align: center;
    background: #ebebeb;
    border-radius: 4px;
    font-size: 12px;
  }

  .title {
    color: grey;
  }
}

.applyCheck {
  .info-must {
    color: #fa5542;
    text-align: center;
    margin: auto;
  }

  .info-title {
    width: 90px;
    text-align: left;
    font-weight: bolder;
    margin: auto;
    text-align-last: justify
  }

  .info-tip {
    font-size: 10px;
    text-align: right;
    margin-top: 2px;
  }
}

.d-table {
  text-align: center;

  .no-data {
    text-align: center;
    margin-top: 60px;
  }

}

.isClickAble {

}

.a-statistic-countdown {
  display: flex;
  align-items: center; /* 垂直居中 */
}

/deep/ .ant-statistic-title {
  color: #fa5542;
  font-size: 14px;
  text-align: center;
  align-content: center;
  margin-left: 22px;
}

/deep/ .ant-statistic-content {
  color: #fa5542;
  font-size: 16px;
  margin-top: -6px;
  margin-left: 4px;
}

.qrcode-content {
  height: 100px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.buy-title {
  font-weight: bold;
  color: #000000;
}

.buy-info {
  background: #ebebeb;
  border-radius: 10px;
  padding: 20px 10px;

  .info-container {
    display: flex;
  }

  .left-div {
    flex: 1; /* 左边占据1份空间 */
    padding: 20px; /* 内边距，可以根据需要调整 */

    .info-img {
      height: 170px;
      width: auto;
      display: block;
      object-fit: cover;
      border-radius: 10px;
      margin: auto
    }
  }

  .right-div {
    flex: 5; /* 右边占据2份空间 */
    display: flex;
    flex-direction: column; /* 竖直排列 */
  }

  .top-div {

    text-align: right;
  }

  .middle-div {
    margin-top: 10px;
    margin-right: 20px;
    text-align: right;
    display: flex;
    justify-content: space-between;
  }

  .bottom-div {

    text-align: left;
  }
}

.buy-img {
  width: 130px;
  height: 50px;
}

.info-status {
  padding: 2px 3px; /* 内边距 */
  //margin: 2px; /* 外边距 */
  // background-color: #ffdddd; /* 背景颜色 */
  text-align: center;
  font-size: 12px;
  border-radius: 20px; /* 圆角的半径 */
  margin-left: 20px;
  margin-right: 20px;
  border: 1px solid dodgerblue; /* 边框宽度和颜色 */
  color: dodgerblue;
}

.info-tips {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 6px;
  top: 8px;
}

.info-must {
  color: #fa5542;
  text-align: center;
  margin: auto 0px;
}

.info-title {
  width: 90px;
  font-weight: bolder;
  margin: auto;
  text-align-last: justify
}

.fax-tips {
  position: relative;
}

/deep/ .ant-modal-body {
  padding: 12px 24px;
}

/deep/ .ant-statistic-content-prefix {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

/deep/ .ant-statistic-content-value {
  color: #fa5542;
  font-size: 16px;
}

/deep/ .ant-statistic-content-suffix {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

</style>
